import { createContext } from "react";
import type { ReactNode } from "react";

/** The page's help line, handed from PortalLayout to the page's Container (ADR-20261102-h2fd). */
export const PageHelpLineContext = createContext<ReactNode>(undefined);
